import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    destroy: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.delete(`/upsales/${url.id}`, config),
    fetch: (config: AxiosRequestConfig) => api.get(`/upsales`, config),
    fetchAll: (config: AxiosRequestConfig) => api.get(`/upsales/all`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/upsales/${url.id}`, config),
    store: (data: object, config: AxiosRequestConfig) =>
        api.post(`/upsales`, data, config),
    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/upsales/${url.id}`, data, config),
};

export default requests;
